var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgMicrosoftTeamsLogin = function SvgMicrosoftTeamsLogin(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 728 448.4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.7,
    cy: 33.9,
    r: 8.4,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M629.8,11.5H87.2A7.58,7.58,0,0,0,79.6,19h0V382.2a7.51,7.51,0,0,0,7.6,7.5H629.1a7.49,7.49,0,0,0,7.5-7.5V28.5h.7V19A7.55,7.55,0,0,0,629.8,11.5Z",
    style: {
      fill: "#7f7f7f",
      opacity: 0.03099999949336052,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.5,17H625.1V372.2a6,6,0,0,1-6,6H204.5Z",
    style: {
      fill: "#f6f6fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,0H619.7a6,6,0,0,1,6,6V17H68.1V6A6,6,0,0,1,74.1,0Z",
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1,17h34.1V378.2H74.1a6,6,0,0,1-6-6Z",
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.1,
    y: 17,
    width: 102.9,
    height: 361.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.7,53.4H264a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5H223.7a1.54,1.54,0,0,1-1.5-1.5h0v-.8a1.42,1.42,0,0,1,1.5-1.5Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.4,69.7h51.9a1.54,1.54,0,0,1,1.5,1.5V72a1.54,1.54,0,0,1-1.5,1.5H136.4a1.54,1.54,0,0,1-1.5-1.5h0v-.8A1.42,1.42,0,0,1,136.4,69.7Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.4,87h25a1.54,1.54,0,0,1,1.5,1.5h0v.8a1.54,1.54,0,0,1-1.5,1.5h-25a1.54,1.54,0,0,1-1.5-1.5h0v-.8a1.42,1.42,0,0,1,1.5-1.5Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.9,52.9h25a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5h-25a1.54,1.54,0,0,1-1.5-1.5v-.8A1.54,1.54,0,0,1,114.9,52.9Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7,67.8H91.8a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5H78.7a1.54,1.54,0,0,1-1.5-1.5v-.8a1.42,1.42,0,0,1,1.5-1.5Z",
    style: {
      fill: "#515ba5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,25.1h75.7a1.54,1.54,0,0,1,1.5,1.5v13a1.54,1.54,0,0,1-1.5,1.5H114a1.54,1.54,0,0,1-1.5-1.5v-13a1.54,1.54,0,0,1,1.5-1.5Z",
    style: {
      fill: "#f6f6fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.4,103.3h48.4a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5H136.4a1.54,1.54,0,0,1-1.5-1.5h0v-.8a1.42,1.42,0,0,1,1.5-1.5Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.4,119.8h48.4a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5H136.4a1.54,1.54,0,0,1-1.5-1.5h0v-.8a1.42,1.42,0,0,1,1.5-1.5Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.4,147.4h58a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5h-58a1.54,1.54,0,0,1-1.5-1.5h0V149a1.55,1.55,0,0,1,1.5-1.6C136.3,147.5,136.3,147.4,136.4,147.4Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.9,358.7h40.4a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5H130.9a1.54,1.54,0,0,1-1.5-1.5v-.8A1.42,1.42,0,0,1,130.9,358.7Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,53.4h12.6a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5H277.3a1.54,1.54,0,0,1-1.5-1.5v-.8a1.54,1.54,0,0,1,1.5-1.5Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,53.4h29.5a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5H305a1.54,1.54,0,0,1-1.5-1.5v-.8a1.54,1.54,0,0,1,1.5-1.5Z",
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.3,53.4H363a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5H346.3a1.54,1.54,0,0,1-1.5-1.5v-.8a1.47,1.47,0,0,1,1.5-1.5Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.4,
    y: 53.8,
    width: 7.6,
    height: 1,
    style: {
      fill: "#3f487f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.7,
    y: 50.5,
    width: 1,
    height: 7.6,
    style: {
      fill: "#3f487f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.7,
    y: 25.3,
    width: 16.3,
    height: 16.1,
    style: {
      fill: "#a7cbf9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 64,
    width: 16.3,
    height: 16.1,
    style: {
      fill: "#06c1bb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 141.5,
    width: 16.3,
    height: 16.1,
    style: {
      fill: "#a7cbf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.5,28.9H364a3.54,3.54,0,0,1,3.5,3.5v1.8a3.54,3.54,0,0,1-3.5,3.5H249.5a3.54,3.54,0,0,1-3.5-3.5V32.4A3.54,3.54,0,0,1,249.5,28.9Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.6,28.9h28.6a3.54,3.54,0,0,1,3.5,3.5v1.8a3.54,3.54,0,0,1-3.5,3.5H385.6a3.54,3.54,0,0,1-3.5-3.5V32.4A3.54,3.54,0,0,1,385.6,28.9Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 624.3,
    y1: 63.1,
    x2: 204.5,
    y2: 63.1,
    style: {
      fill: "none",
      stroke: "#dfdfea",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.7,
    cy: 33.9,
    r: 8.4,
    style: {
      fill: "#70a9e8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.2,
    cy: 60.4,
    r: 5.8,
    style: {
      fill: "#515ba5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.1,
    y: 78.3,
    width: 33.6,
    height: 29.1,
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7,96.3H91.8a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5H78.7a1.54,1.54,0,0,1-1.5-1.5v-.8c-.1-.8.6-1.4,1.5-1.5C78.6,96.4,78.6,96.3,78.7,96.3Z",
    style: {
      fill: "#515ba5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.2,
    cy: 88.9,
    r: 5.8,
    style: {
      fill: "#515ba5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7,126.6H91.8a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5H78.7a1.54,1.54,0,0,1-1.5-1.5h0v-.8a1.42,1.42,0,0,1,1.5-1.5Z",
    style: {
      fill: "#515ba5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.2,
    cy: 119.2,
    r: 5.8,
    style: {
      fill: "#515ba5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6,331.4H91.7a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5H78.6a1.54,1.54,0,0,1-1.5-1.5v-.8A1.47,1.47,0,0,1,78.6,331.4Z",
    style: {
      fill: "#515ba5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.2,
    cy: 323.9,
    r: 5.8,
    style: {
      fill: "#515ba5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.5,
    cy: 360.1,
    r: 4.6,
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7,360H91.8a1.54,1.54,0,0,1,1.5,1.5v.8a1.54,1.54,0,0,1-1.5,1.5H78.7a1.54,1.54,0,0,1-1.5-1.5v-.8a1.42,1.42,0,0,1,1.5-1.5Z",
    style: {
      fill: "#515ba5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.2,
    cy: 352.6,
    r: 5.8,
    style: {
      fill: "#515ba5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.7,
    y: 61.2,
    width: 32,
    height: 2.2,
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 577.5,
    y: 8.3,
    width: 7.3,
    height: 1.3,
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.8,6.6l-.9-.9-2.1,2.1-2.1-2.1-.9.9,2.1,2.1-2.1,2.1.9.9,2.1-2.1,2.1,2.1.9-.9-2.1-2.1Z",
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.3,5.4h-7.5v5.8h0v.9h7.5V6.3h0ZM594,10.8V6.6h5.1v4.2Z",
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2,31.7a2.34,2.34,0,0,1,.1-2c.4-.5.9-.3,1.2.3a3.72,3.72,0,0,1,.5,2.3C90.6,33.2,89.7,33,89.2,31.7Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3,38.4c-.7,2.4-2.5,7.8-4.2,7.5a3.37,3.37,0,0,1-2.2-2h0a1.93,1.93,0,0,1,.3-1,31.16,31.16,0,0,1,3.9-5.6Z",
    style: {
      fill: "#a7cbf9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.7,
    cy: 33.3,
    rx: 4.7,
    ry: 5,
    transform: "translate(-5.48 21.51) rotate(-13.87)",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9,31.7a.37.37,0,0,1-.1.3Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9,34.6a2.32,2.32,0,0,1,1.6-.3",
    style: {
      fill: "none",
      stroke: "#d88d6a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2,36.8l2.4,3.6a3.44,3.44,0,0,0,3-2.4l-2.5-3Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6,36.2a5.29,5.29,0,0,1-1.1,2.1c-.7.6-.9.9-.6,1.3s.7,1.5,1.3,1.5,1.3-2,1.6-2.5a2,2,0,0,0,.2-1.1C92,37.6,91.4,36.5,90.6,36.2Z",
    style: {
      fill: "#a7cbf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9,39.2a2.48,2.48,0,0,0,0,1.7,1.27,1.27,0,0,0,.9.7s.4-.1.2-.8c-.1-.2-.2-.5-.3-.7A7.27,7.27,0,0,1,87.9,39.2Z",
    style: {
      fill: "#a7cbf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1,40.3l-.4-.1-.3-.5s-.1,1.2.6,1.5",
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,39.8c.1.1.7,2,1.5,1.6a4.9,4.9,0,0,0,1.1-2",
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3,36.4l.3.4.2-.5S90.6,36.1,90.3,36.4Z",
    style: {
      fill: "#a7cbf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5,29.5a1.38,1.38,0,0,0-.3.4v.2h0v.3l-.3,1.3-.1.3c-.2-.9-.8-2.5-1.9-2.5a2.66,2.66,0,0,0-1.2.3c-.4.3-.5.9-.8,1.2a4.41,4.41,0,0,1-3.8,1.7,2.93,2.93,0,0,1-2.5-3.3h0a1.85,1.85,0,0,1,.2-.7,2.54,2.54,0,0,1,2.6-1.6,2.72,2.72,0,0,1,1.7.6,3.29,3.29,0,0,1,2.5-.8,4,4,0,0,1,2.6,1,5.24,5.24,0,0,1,1,1.1h0C89.3,29,89.5,29.2,89.5,29.5Z",
    style: {
      fill: "#1b1e27"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383,184.8c-40.4-18.9-45.9-53.1-45.9-53.1s37.5,20.1,46.8,50.6h0Z",
    style: {
      fill: "none",
      stroke: "#97a1c0",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.9,181l-5-1.3-5-1.3,2.6-2.2,1-3.2,3.2,4.1Z",
    style: {
      fill: "#97a1c0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.8,
    cy: 126.1,
    r: 16.9,
    style: {
      fill: "#1bae5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.6,134.3h-4.5l5.1-8-4.8-8H329c.5.9.9,1.8,1.3,2.7s1,1.8,1.4,2.7l.1-.2.1-.2,2.7-5.1h4.3l-4.9,8,5,8.1h-4.5l-3-5.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.1,235s35.5-27.6,62.2-39.2",
    style: {
      fill: "none",
      stroke: "#97a1c0",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.5,201l-3.4,3.9-3.4,3.8-.8-3.3-2.5-2.4,5.1-1Z",
    style: {
      fill: "#97a1c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.2,282.2s-10.6-44.8-13.4-81.9",
    style: {
      fill: "none",
      stroke: "#97a1c0",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.6,208.9l2.1,4.7,2.1,4.7-3.4-.6-3.2,1.3,1.1-5Z",
    style: {
      fill: "#97a1c0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.7,
    cy: 280.1,
    r: 15.3,
    style: {
      fill: "#1bae5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.2,215.2s-49.8-13.2-67.4-21.9",
    style: {
      fill: "none",
      stroke: "#97a1c0",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.2,197.3l5.2.1,5.2.1-2,2.8-.2,3.4-4.1-3.2Z",
    style: {
      fill: "#97a1c0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.7,
    cy: 218,
    r: 16.3,
    style: {
      fill: "#1bae5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,213.2a.47.47,0,0,0-.5.5h0v8.6a.54.54,0,0,0,.5.5h4.7a.47.47,0,0,0,.5-.5h0v-2.4h-1.9v1h-1.9v-5.8h1.9v1h1.9v-2.4a.54.54,0,0,0-.5-.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.2,213.2l1.9,9.4a.22.22,0,0,0,.2.2h1.5a.22.22,0,0,0,.2-.2l1.9-9.4H476l-1,4.8-1-4.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.7,213.2a1.58,1.58,0,0,0-1.6,1.6v2.6a1.58,1.58,0,0,0,1.6,1.6H469v1.9h-3.9v1.9h4.2a1.58,1.58,0,0,0,1.6-1.6h0v-2.6a1.58,1.58,0,0,0-1.6-1.6H467v-1.9h3.9v-1.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.9,123.9s-34.5,39.7-53.3,59.2",
    style: {
      fill: "none",
      stroke: "#97a1c0",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.8,177.7l2.1-4.7,2.1-4.7,1.8,2.9,3,1.6-4.5,2.5Z",
    style: {
      fill: "#97a1c0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.1,
    cy: 123.9,
    r: 14.8,
    style: {
      fill: "#1bae5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,129.1H440.1v-8.7H454m0-1.7h-7l-1.7-1.7h-5.2a1.69,1.69,0,0,0-1.7,1.7h0v10.4a1.69,1.69,0,0,0,1.7,1.7H454a1.75,1.75,0,0,0,1.7-1.7h0v-8.7a1.69,1.69,0,0,0-1.7-1.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 190.7,
    r: 15.3,
    style: {
      fill: "#1bae5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.1,247.8h-3.6l4.1-6.5-3.8-6.4h3.7c.4.7.7,1.4,1.1,2.2a22.56,22.56,0,0,1,1.1,2.2l.1-.1.1-.1,2.2-4.1h3.5l-3.9,6.4,4,6.5H316l-2.4-4.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.4,197.4h-3.9l4.5-7-4.1-6.9h3.9c.4.8.8,1.6,1.1,2.3a25.32,25.32,0,0,0,1.2,2.3l.1-.1.1-.1,2.4-4.4h3.7l-4.2,6.9,4.3,7h-3.9l-2.5-4.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.5,
    cy: 241.3,
    r: 14.5,
    style: {
      fill: "#1bae5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.1,247.8h-3.6l4.1-6.5-3.8-6.4h3.7c.4.7.7,1.4,1.1,2.2a22.56,22.56,0,0,1,1.1,2.2l.1-.1.1-.1,2.2-4.1h3.5l-3.9,6.4,4,6.5H316l-2.4-4.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.8,287.3h-4.1l4.7-7.4-4.4-7.4h4.2c.4.8.8,1.7,1.2,2.5s.9,1.7,1.3,2.5l.1-.2.1-.1,2.5-4.6h4l-4.5,7.3,4.5,7.5h-4.1l-2.7-5.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,255.4v-94a9.35,9.35,0,0,0-9.3-9.3H18.5a9.35,9.35,0,0,0-9.3,9.3h0v94h0v24.4a9.26,9.26,0,0,0,9.2,9.3H196.6a9.28,9.28,0,0,0,9.3-9.3h0V255.4Z",
    style: {
      fill: "#7f7f7f",
      opacity: 0.07999999821186066,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.5,414.7v-94a9.35,9.35,0,0,0-9.3-9.3H425a9.28,9.28,0,0,0-9.3,9.3h0v94h0v24.4a9.26,9.26,0,0,0,9.2,9.3H603.1a9.28,9.28,0,0,0,9.3-9.3h0l.1-24.4Z",
    style: {
      fill: "#7f7f7f",
      opacity: 0.07999999821186066,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.9,416.4l-195.8-8.1V314.8a8.81,8.81,0,0,1,8.8-8.8H596.1a8.81,8.81,0,0,1,8.8,8.8Z",
    style: {
      fill: "#e9f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.9,306.5a8.28,8.28,0,0,0-8.3,8.3v93l194.8,8.1V314.8a8.26,8.26,0,0,0-8.2-8.3H417.9m0-1H596.1a9.28,9.28,0,0,1,9.3,9.3h0V417l-196.8-8.1v-94a9.24,9.24,0,0,1,9.3-9.4Z",
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.4,408.8v24.4a9.35,9.35,0,0,1-9.3,9.3H417.9a9.26,9.26,0,0,1-9.3-9.2h0V408.9l196.8-.1Z",
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.1,
    cy: 424.4,
    r: 9.8,
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491,
    cy: 424.4,
    r: 9.8,
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523,
    cy: 424.4,
    r: 9.8,
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 424.4,
    r: 9.8,
    style: {
      fill: "#f04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.5,399.1l-24.3.5,1.1-31,22.4,5.3Z",
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9,378.1l-77-7.6a2,2,0,0,1-1.8-1.8l-.2-53.8a1.93,1.93,0,0,1,2.1-1.8h.3l77.2,12.2a2,2,0,0,1,1.7,1.8v49.2a1.93,1.93,0,0,1-2.1,1.8Z",
    style: {
      fill: "#f3faff",
      stroke: "#75afef",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.3,337s5.7,3.2,7.5,6.1,15.6,27.2,17.1,30.9,3.8,8.8,1,13.1-11,11.1-11,11.1L543,336.3",
    style: {
      fill: "#2979ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 529.6,
    cy: 308.5,
    r: 16.2,
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519,302.8c-.3-.4-4.3-3.1-5.6-2.6s-4.3,14,7.3,22.1Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538,319.2a3.73,3.73,0,0,1,3.9-3.8c3.3.2,5.6,5.2,3,7.8S539.9,323.9,538,319.2Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.5,296.4c.5,4.6,6.3,5.6,7.5,9.6.7,2.1,0,9.1-2.8,10.2,1.9-1,3.1-.1,5.8-.4,2.1-.2,4-1.9,5.2-3.5,5.4-7.2-7-17.5-11.9-20.9C537,290.9,534.4,294.8,534.5,296.4Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.1,298.5s-1.6.8-4.7-.3-7.8-3.5-8.6-6.8,1.7-8.5,5.6-9,8.2.6,10.3,4,1.9,8.1.8,9.5A11.86,11.86,0,0,1,538.1,298.5Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.2,320.5c.2.5,3,12.1,3,12.1l9.5-4.4-2.4-7.3Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.9,300.4s2.8.1,3.7,1.8",
    style: {
      fill: "none",
      stroke: "#d88d6a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.8,313.4c0,.1-5.3,4.1-5.3,4.1l.2.9,3.7-.7Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.9,332.8s-2.1-5-3.4-4.9-8.2,2.2-10.3,4.7-3,4.2-2.3,6.9,1.5,3.3,2.6,2.2,9-7,11-7.5S538.9,332.8,538.9,332.8Z",
    style: {
      fill: "#a7cbf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.6,333s-5.5,3.1-6,5.7.2,5.4,1.1,6,3.7-2.2,4.4-3.5S525.6,333,525.6,333Z",
    style: {
      fill: "#a7cbf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.8,362.1s-1.7,15.3-.8,23.3,3,11.3,3,11.3l2.9,12.1h42.6s-19.4-66.9-21.9-70.7-4.6-6-6.6-5.3-12.2,7.3-14,9.3S521.2,357.1,519.8,362.1Z",
    style: {
      fill: "#2979ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.5,389.9c.4-.3,34.8-8.6,37.2-9.8a12.59,12.59,0,0,0,7.3-8.6c1.4-5.3,3.6-29.5,7.6-30.6s10,1.7,11.7,9.9-6.1,40.9-9.3,44.1-12,5-14.7,4.5-36.8-1.6-37.3-1.4S476.1,391.2,477.5,389.9Z",
    style: {
      fill: "#2979ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.9,389.3s-1.4-4.3-3.8-3.5-4,1.6-3.8,4.2,2.5,8.5,2.5,8.5l6.6-.1Z",
    style: {
      fill: "#2979ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.5,397.9a6.65,6.65,0,0,0,6.4-.6,27.3,27.3,0,0,0,11.6-16.9,166.26,166.26,0,0,0,3.7-21.1",
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.1,344.8s11.7,36.4,12.8,41",
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.6,342.3l.7,1s-.7,3.7-.8,5,4.5-3.8,6.9-6.2,9.5-9.2,9.5-9.2-6.9,1.8-10.1,5.4Z",
    style: {
      fill: "#a7cbf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.7,339s0,5.3,1.6,4.1a32.32,32.32,0,0,0,3.7-3.7",
    style: {
      fill: "none",
      stroke: "#187dea",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.1,324.2s4.8,1.2,10.6-2.3",
    style: {
      fill: "none",
      stroke: "#d88d6a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.8,
    y: 397.9,
    width: 115.3,
    height: 11,
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6,397.6s4.9-7.4,9.6-7.1,11.9,7.5,11.9,7.5Z",
    style: {
      fill: "#4b92d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.1,392.5a72.52,72.52,0,0,0-7.5-4.7c-3.5-1.8-11.2-3.4-13.4-1.4a45.72,45.72,0,0,0-4.3,4.5c-.6.7-4.8,2.2-3.9,3.9a2.93,2.93,0,0,0,2.7,1.9c.3-.1,5.7-2.2,7.2-2.5s2.6-.1,4.8,1.5,3.4,1.5,7.2,1.2a74.78,74.78,0,0,1,8.2.1Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.1,381.1l4.5,1a1.7,1.7,0,0,1,1.3,2h0l-1.5,7.3a1.7,1.7,0,0,1-2,1.3h0l-3.9-.8Z",
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.4,397l5.3.2a5.74,5.74,0,0,0,5.8-5l2.4-22.3a5.63,5.63,0,0,0-5-6.2h-.5l-7-.2a5.59,5.59,0,0,0-5.8,5.4l-.8,22.3a5.83,5.83,0,0,0,5.6,5.8Z",
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.4,390.3l-4.6,18.4h2.9l4.4-17.9Z",
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.1,393.8l.1-.7a1.27,1.27,0,0,1,1.5-1l3.2.5a1.27,1.27,0,0,1,1,1.5l-.1.7a1.27,1.27,0,0,1-1.5,1l-3.2-.5A1.39,1.39,0,0,1,587.1,393.8Z",
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.1,397.4l.1-.7a1.27,1.27,0,0,1,1.5-1l3.2.5a1.27,1.27,0,0,1,1,1.5l-.1.7a1.27,1.27,0,0,1-1.5,1l-3.2-.5A1.33,1.33,0,0,1,586.1,397.4Z",
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585,401l.1-.7a1.27,1.27,0,0,1,1.5-1l3.2.5a1.27,1.27,0,0,1,1,1.5l-.1.7a1.27,1.27,0,0,1-1.5,1l-3.2-.5A1.42,1.42,0,0,1,585,401Z",
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584,404.6l.1-.7a1.27,1.27,0,0,1,1.5-1l3.2.5a1.27,1.27,0,0,1,1,1.5l-.1.7a1.27,1.27,0,0,1-1.5,1l-3.2-.5A1.42,1.42,0,0,1,584,404.6Z",
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.2,316.6v5.9l4.4.4v-5.4Z",
    style: {
      fill: "#1bae5b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.5,
    y1: 325.1,
    x2: 492.7,
    y2: 336.2,
    style: {
      fill: "none",
      stroke: "#e9f5ff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.7,
    y1: 357.4,
    x2: 419.5,
    y2: 347.8,
    style: {
      fill: "none",
      stroke: "#e9f5ff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.7,
    y1: 371,
    x2: 419.5,
    y2: 363.2,
    style: {
      fill: "none",
      stroke: "#e9f5ff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.6,346.3c1,7-3.3,13.5-9.7,14.4s-12.3-4.1-13.3-11.1,3.3-13.5,9.6-14.4a10.68,10.68,0,0,1,6.3,1l-2.9,11.9,9.7-3.1C444.4,345.4,444.5,345.9,444.6,346.3Z",
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.6,346.6l-10,1.7,4.6-11.4A12.89,12.89,0,0,1,444.6,346.6Z",
    style: {
      fill: "#2979ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.3,352.9l-4.9-.7.2-15.7,4.7.7Z",
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.5,353.6l-4.8-.5.1-20.5,5,.8Z",
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.2,354.6l-4.8-.7.1-12.7,4.9.7Z",
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484,355.5l-5-.6.5-16.3,4.8.7Z",
    style: {
      fill: "#75afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.9,364.2s4-10.2,7.2-5.5,2.5,8.4,8.4,5.3,6.9-4.2,9.8,0",
    style: {
      fill: "#f3faff",
      stroke: "#75afef",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.2,171.9v-94a9.35,9.35,0,0,0-9.3-9.3H517.7a9.28,9.28,0,0,0-9.3,9.3v94h0v24.4a9.26,9.26,0,0,0,9.2,9.3H696a9.26,9.26,0,0,0,9.3-9.2h0l-.1-24.5Z",
    style: {
      fill: "#7f7f7f",
      opacity: 0.07999999821186066,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.7,162.5V69a8.88,8.88,0,0,1,8.8-8.8H687.7a8.81,8.81,0,0,1,8.8,8.8v93.5Z",
    style: {
      fill: "#fff1dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.7,60.8a8.28,8.28,0,0,1,8.3,8.3v93H501.2V69a8.28,8.28,0,0,1,8.3-8.3l178.2.1m0-1H509.5a9.28,9.28,0,0,0-9.3,9.3v94H697V69A9.26,9.26,0,0,0,687.7,59.8Z",
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.4,139.5h-.2l-10.6.2a2,2,0,0,1,0-4l10.6-.2a2,2,0,1,1,.2,4Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.1,133.6h-.2l-6.9.2a2,2,0,0,1,0-4l6.9-.2a2,2,0,0,1,2.1,1.9,1.89,1.89,0,0,1-1.9,2.1Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.9,140.6c-.5,5.2-2.1,19.2-4.3,21.3H671.2c-1.1-.2-3.4-15.2-3.8-20.9v-.1h0a2.05,2.05,0,0,1,2-2.2l17.9.1h.1A1.6,1.6,0,0,1,688.9,140.6Z",
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.6,158.7a9.51,9.51,0,0,1-7.2-2.3,11.47,11.47,0,0,1-3.9-9.7,6.27,6.27,0,0,1,2.7-5.1c3.1-2.1,7.4-.9,7.9-.8l-1.1,3.6.5-1.8-.5,1.8c-.8-.2-3.3-.6-4.7.3a2.73,2.73,0,0,0-1,2.3,7.89,7.89,0,0,0,2.6,6.6,6,6,0,0,0,5,1.4l.9,3.7A2.4,2.4,0,0,0,669.6,158.7Z",
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565,55.8a7.57,7.57,0,0,0,1.5-.1A7.57,7.57,0,0,1,565,55.8Z",
    style: {
      fill: "#7d543d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589,64.9v.6a17.91,17.91,0,1,1-29.6-14.1c0-.1.1-.2.1-.3a18,18,0,0,1,25.3,2.3A17.55,17.55,0,0,1,589,64.9Z",
    style: {
      fill: "#7d543d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565,55.8a7.57,7.57,0,0,0,1.5-.1A7.57,7.57,0,0,1,565,55.8Z",
    style: {
      fill: "#7d543d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.5,68c0-.3,2.4-2.8,4.8-2.5s3.7,2.1,2.9,4.5-3.5,3.7-4.9,3.4-2.9-2-2.9-2.6S586.5,68,586.5,68Z",
    style: {
      fill: "#7d543d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.1,67.3s1.1-1.4,4.8-.5",
    style: {
      fill: "none",
      stroke: "#513020",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.1,79.6l.5,12.3,7.1,2.4,6.2-4-1.5-12.2Z",
    style: {
      fill: "#7d543d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.9,83.4a4.68,4.68,0,0,1,3.1.5c1.2,1,1.7,6.6,1.3,8.2s-6.2,6.9-7.6,6.7-2.8-6.2-1.5-8.5,5.1-4.2,5.1-4.2Z",
    style: {
      fill: "#ffd180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.7,90.9c-.1.2.4,7.5-1.2,7.9s-5.5-2.1-7.3-4.6-2.5-2.4-2.1-4.2,2.1-4.9,2.8-5.3a1.53,1.53,0,0,1,1.3-.2,2.12,2.12,0,0,0,1.5,2.4C569.7,87.5,572.8,90.6,572.7,90.9Z",
    style: {
      fill: "#ffd180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.2,91.5c-4.6,11.3-14.7,29.2-15.2,29.1-6.5-8.2-23.7-22.7-31.7-29.1C569.5,87.9,588.7,90.3,596.2,91.5Z",
    style: {
      fill: "#ffd180"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.3,82.1c2.4-.2,4.9-.8,6.5-2.3",
    style: {
      fill: "none",
      stroke: "#513020",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.8,92.2s.8,4.8-1.7,5.5",
    style: {
      fill: "none",
      stroke: "#c67c00",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.4,94.1s-.4,4.2,2,3.7",
    style: {
      fill: "none",
      stroke: "#c67c00",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.2,114.9c.4,5.6.7,11.3.7,16a204.69,204.69,0,0,1-3,31.2H560.8s-11.5-20.9-14.4-30.6c-1.1-3.9-2.6-9.2-3.9-14.5-7.8,6-29,19.7-31.9,18.6a3.87,3.87,0,0,1-2.2-3.4c-2.5-4.5-9.5-17-11.6-21.9-2.6-6-9.2-18.5-8.6-19.6s6.3-4.5,8.5-3.8,15.5,21.9,21.2,25.9a22,22,0,0,1,1.8,1.4c7.8-8.1,17.8-18.2,19.4-19.4a9.88,9.88,0,0,1,3.3-1.5,10.92,10.92,0,0,1,4.9-1.6c.6-.1,1.2-.2,1.9-.3,8,6.4,25.2,21,31.7,29.1.5.2,10.6-17.8,15.2-29.1l3.3.6Z",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.4,92.2a5.66,5.66,0,0,1,3,0c1.1.5,21.2,26,23.2,30.7s3,7.5-3.1,9.4-12.5.9-14.5-1.6l-7.9-9.9Z",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.2,91.4c0-.2-1.1-5.7-1.1-5.7a62.12,62.12,0,0,1-6.8-.4,96.17,96.17,0,0,1-7.8-6.1,4.72,4.72,0,0,1-1.6-3.2,18.11,18.11,0,0,0-1.2-5.6c-1.3-3.3-2.6-6.3-1.6-7s4-.7,4.8,1a17.2,17.2,0,0,0,1.3,2.4s2-.7,3.1.7,2.6,7,2.7,7.5,6.5.9,7.9,1.9,1.4-6.3,1.5-7,1.5-1.1,3.4-.5,2.4.8,2.3,2.2-.1,9.8-.2,10.9-.2,4.8.7,5.9C496.7,88.3,489.2,91.4,489.2,91.4Z",
    style: {
      fill: "#7d543d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.5,133.3a1.86,1.86,0,0,0-1.2.9,1.93,1.93,0,0,0,.7,2.6,1.42,1.42,0,0,0,.6.2C587.4,137.7,588.7,134,585.5,133.3Z",
    style: {
      fill: "#c67c00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.4,144.4a2.15,2.15,0,0,0-1.2.9,1.93,1.93,0,0,0,.7,2.6h0a1.45,1.45,0,0,0,.7.2C589.3,148.8,590.7,145,587.4,144.4Z",
    style: {
      fill: "#c67c00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.3,96.5s22.7,18.8,29.3,27.4a150.49,150.49,0,0,0,10.7-18.7",
    style: {
      fill: "none",
      stroke: "#c67c00",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.2,91.4a34.91,34.91,0,0,0,7.5-3.1",
    style: {
      fill: "none",
      stroke: "#c67c00",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.3,115.4a7,7,0,0,1,1.8,4.8",
    style: {
      fill: "none",
      stroke: "#c67c00",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589,64.9v.6l-3.5,1.4s.5-3.1.4-3.1c0-4.9-2.8-7.1-4.9-8.6-2.9-2.1-12.2,1.1-17.5.5-4.5-.5-4.8-2.7-4-4.6a18,18,0,0,1,25.3,2.3A17.55,17.55,0,0,1,589,64.9Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697,163v24.4a9.26,9.26,0,0,1-9.2,9.3H509.5a9.33,9.33,0,0,1-9.3-9.2h0V163Z",
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 550.6,
    cy: 178.7,
    r: 9.8,
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.6,
    cy: 178.7,
    r: 9.8,
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 614.6,
    cy: 178.7,
    r: 9.8,
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 646.5,
    cy: 178.7,
    r: 9.8,
    style: {
      fill: "#f04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5,258.2V152.8A8.81,8.81,0,0,1,9.3,144H187.5a8.81,8.81,0,0,1,8.8,8.8V254.5Z",
    style: {
      fill: "#ffe9f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3,144.5A8.28,8.28,0,0,0,1,152.8H1v105L195.8,254V152.8a8.28,8.28,0,0,0-8.3-8.3H9.3m0-1H187.5a9.28,9.28,0,0,1,9.3,9.3V254.9L0,258.8v-106a9.22,9.22,0,0,1,9.3-9.3Z",
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.8,246.8v24.4a9.26,9.26,0,0,1-9.2,9.3H9.3A9.33,9.33,0,0,1,0,271.3H0V246.8Z",
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.4,
    cy: 262.4,
    r: 9.8,
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.4,
    cy: 262.4,
    r: 9.8,
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.4,
    cy: 262.4,
    r: 9.8,
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.3,
    cy: 262.4,
    r: 9.8,
    style: {
      fill: "#f04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6,155.3s-3.8.3-4.6-2.9a7.22,7.22,0,0,1,.5-5.2l4.1,1.2Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8,195.4l-1.2-9.5,5.9-.2s29.9-1.4,32.6-1.4,8.1.2,9.6,2.5,5,23.1,12.7,28.6S130.7,230,130.7,230l-15.6,10.6-5.2-.8-5.2-8.6s-2.7-1-2.7.8a37.62,37.62,0,0,1-1.2,6.7c-.2.6-22.3-5.5-22.3-5.5Z",
    style: {
      fill: "#f04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7,158.3c.1.4,1.3,14.5,14.3,15.1,0,0,14.2.9,17.5-10.8a13,13,0,0,0,0-6.2c-.8-3-1.8-4.2-3-7.6s-2.2-5.5-3.7-6.4a17.68,17.68,0,0,0-4.1-2.1c-2.1-.6-15.4-.9-19.5,6.5C66.1,146.9,63.6,153.8,64.7,158.3Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8,157.6s1.9-2.5,4.2-1.7",
    style: {
      fill: "none",
      stroke: "#d8854c",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5,139c.4.5,2.6,3.3-.6,7.5S71.5,157,66.7,156.2s-6.4-2-6.5-4.6,2.3-11.9,8.4-14.6S81.1,132.2,86.5,139Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9,138c.6-.1,6.2.5,7.8,3.1a7.53,7.53,0,0,1,.8,5.3,8.46,8.46,0,0,0-5.4-5.2Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8,148.8c-.7,0,.2-2.8-7.4-4.7s-13.8-.9-18.1,5.9-4.5,16.9.7,21.2,12.3,3.1,17.8,0a22.12,22.12,0,0,0,8.3-8.6Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,168.3c-.1.4-1,16.3-1,16.3s9,2.4,10.6.7,2-16.6,2-16.6Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6,186c.3.2,6.6-1.1,10.6-2.7s4.2-1.5,7.5-1.5,15.5,2.5,16.4,2.6,2.4,3-.7,6-5.1,8.3-11.2,7.7S60.6,186,60.6,186Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7,203.6a43.05,43.05,0,0,0,5.2,10.8c2.9,4,4.5,4.6,2.9,7.4a44.42,44.42,0,0,0-2.4,4.9",
    style: {
      fill: "none",
      stroke: "#c3001d",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.2,233.1l23.5,3.6-1.3,7.5h-27l-6.3-3.6Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2,160.3s-2.1-3.3-4.6-1.8-3.2,5.2-.9,6.8,6.2,3.4,6.7.5A8.17,8.17,0,0,0,67.2,160.3Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6,156.2c.2.3,3.6,2.9,4.6,5.3s2.2.9,2-1.3-.1-8.9-1.8-9.8S62.6,156.2,62.6,156.2Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,147.4a3,3,0,0,0-3-.5c-1.6.7,1.1,8.1,2.7,9C61,155.8,59.9,149,61.2,147.4Z",
    style: {
      fill: "#f04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4,204.8a10.41,10.41,0,0,0-2.1-5.6",
    style: {
      fill: "none",
      stroke: "#c3001d",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8,193.2c1,.6,1.5,1.4,1.4,3.4",
    style: {
      fill: "none",
      stroke: "#c3001d",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,212.1s-21.4-.5-20.9,5.3,6.6,29.2,6.6,29.2H63.4Z",
    style: {
      fill: "#1a1e28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7,186s-5.6,1.8-6.9,5.6,8.9,47.9,9.1,51.6c.2,3.1,1,4,1,4s16-.4,18.5-.4-5.9-9.2,2.5-11.5c0,0-.1-9.2-2.5-15.6s-5.1-17.7-8.6-22.5S56.7,186,56.7,186Z",
    style: {
      fill: "#f04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2,201.2h0c.4-.9,1.6-4,2.3-4.2",
    style: {
      fill: "none",
      stroke: "#c3001d",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.4,244.7s-4-6.8-6.6-7.2-5.9,1.1-7.6,2-6.6.9-6.6.9l-3.6-.5-29.8-6.4s-7.2,2.6-7.7,7.2,5,5.9,6.9,5.9,53.4.1,54.4,0a6.47,6.47,0,0,1,2.4.1Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.1,209.1l-45-2.2a2.92,2.92,0,0,0-3,2.1l-10.8,35.7h-33v2.1h82.9v-2.1l10.7-33.1a1.9,1.9,0,0,0-1.2-2.4A1.27,1.27,0,0,0,193.1,209.1Z",
    style: {
      fill: "#1a1e28"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.1,
    cy: 140,
    rx: 19.7,
    ry: 17.9,
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.3,147.8l-3.4,8.4a.78.78,0,0,0,.5,1.1.85.85,0,0,0,.7,0l7.6-3.6Z",
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 476.8,
    cy: 285.6,
    rx: 19.7,
    ry: 17.9,
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.3,289.4l7.2,5.5a.83.83,0,0,1,.2,1.2h0a.71.71,0,0,1-.6.3l-8.3.7Z",
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.9,
    cy: 140.4,
    r: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.7,
    cy: 140.4,
    r: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.4,
    cy: 140.4,
    r: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 524.8,
    cy: 49.6,
    rx: 19.7,
    ry: 17.9,
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8,57.1l3.4,8.4a.81.81,0,0,1-.5,1.1.85.85,0,0,1-.7,0L534.5,63Z",
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 518,
    cy: 49.6,
    r: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.8,
    cy: 49.6,
    r: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.5,
    cy: 49.6,
    r: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 469.5,
    cy: 286.5,
    r: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.2,
    cy: 286.5,
    r: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483,
    cy: 286.5,
    r: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.5,162l12.4-36.2h65L661.3,162Z",
    style: {
      fill: "#dfdfea"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635.8 146.4 630.3 146.5 631.9 141.2 637.5 141.2 635.8 146.4",
    style: {
      fill: "#6068ba",
      opacity: 0.07999999821186066,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "643.7 146.3 638.2 146.4 639.9 141.2 645.4 141.1 643.7 146.3",
    style: {
      fill: "#6068ba",
      opacity: 0.07999999821186066,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "633.8 152.9 628.4 153 629.9 147.9 635.4 147.9 633.8 152.9",
    style: {
      fill: "#6068ba",
      opacity: 0.07999999821186066,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "641.5 152.8 636.1 152.9 637.7 147.8 643.2 147.8 641.5 152.8",
    style: {
      fill: "#6068ba",
      opacity: 0.07999999821186066,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.6,132.1s-12.1-1-11.4,5.5,5.6,24.4,8.4,24.4h17.2Z",
    style: {
      fill: "#c67c00"
    }
  }));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrosoftTeamsLogin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microsoft-teams-login.5f4a4364.svg";
export { ForwardRef as ReactComponent };